import React from "react";
import { CheckCircle, XCircle, Circle, ClockClockwise } from "phosphor-react";
import { statusBadgeStyles } from "constants/common";

// Icon per status
const StatusIcon = ({ status }) => {
  switch (status) {
    case "created":
    case "approved":
    case "completed":
      return (
        <CheckCircle
          size={32}
          color="#28a745"
          style={{ marginLeft: "-14px" }}
        />
      );
    case "resubmitted":
      return (
        <ClockClockwise
          size={32}
          color="#0d6efd"
          style={{ marginLeft: "-14px" }}
        />
      );
    case "rejected":
    case "denied":
      return (
        <XCircle size={32} color="#dc3545" style={{ marginLeft: "-14px" }} />
      );
    default:
      return (
        <CheckCircle
          size={32}
          color="#adb5bd"
          style={{ marginLeft: "-14px" }}
        />
      );
  }
};
const getRejectionReason = (step) => {
  if (!step) return null;

  if (step.rejection_reason) return step.rejection_reason;
  if (step.reason) return step.reason;
  if (step.comment) return step.comment;
  if (step.remarks) return step.remarks;
  if (step.notes) return step.notes;
  if (step.rejectionReason) return step.rejectionReason;

  if (step.meta?.rejection_reason) return step.meta.rejection_reason;
  if (step.meta?.reason) return step.meta.reason;

  try {
    const logger = JSON.parse(step.activity_logger || "{}");
    return (
      logger.rejection_reason ||
      logger.reason ||
      logger.comment ||
      logger.remarks ||
      logger.notes ||
      null
    );
  } catch (e) {
    return null;
  }
};
const ApprovalStepper = ({ housingExpense }) => {
  const record = Array.isArray(housingExpense)
    ? housingExpense[0]
    : housingExpense;

  if (!record || !record.housing_expense_logs?.length) {
    return (
      <div className="text-center text-muted py-4">
        No approval history available.
      </div>
    );
  }

  const steps = [...record.housing_expense_logs].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at),
  );

  return (
    <div
      className="container"
      style={{
        background: "rgba(10, 10, 10, 0.05)",
        maxHeight: "400px",
        overflowY: "auto",
        borderRadius: "10px",
        padding: "10px",
      }}
    >
      <ul className="list-unstyled position-relative ms-4">
        {steps.map((step, index) => {
          const badge = statusBadgeStyles[step.status] || {
            text: step.status,
            className: "badge bg-secondary",
            barColor: "#adb5bd",
          };

          let actorName = "System";
          let loggerUser = {};

          try {
            const logger = JSON.parse(step.activity_logger || "{}");
            loggerUser = logger || {};
            actorName =
              `${logger.first_name || ""} ${logger.last_name || ""}`.trim() ||
              "Unknown User";
          } catch (e) {}

          const rejectionReason = getRejectionReason(step);

          return (
            <li key={step.id} className="d-flex position-relative mb-4">
              {/* Vertical timeline bar */}
              {index < steps.length - 1 && (
                <div
                  className="position-absolute start-0"
                  style={{
                    width: "2px",
                    height: "100%",
                    backgroundColor: badge.barColor || "#adb5bd",
                    left: "15px",
                    zIndex: 0,
                    top: "30px",
                  }}
                />
              )}

              {/* Status icon */}
              <div className="me-3 position-relative" style={{ zIndex: 10 }}>
                <StatusIcon status={step.status} />
              </div>

              {/* Text */}
              <div>
                <div>
                  <strong>{loggerUser?.type || "N/A"}</strong>{" "}
                  <span className="text-muted">({actorName})</span>
                </div>
                <span className={`badge ${badge.className} me-2`}>
                  {badge.text}
                </span>
                <div className="text-muted small">
                  {step.created_at
                    ? new Date(step.created_at).toLocaleString()
                    : "N/A"}
                </div>

                {(step.status === "denied" || step.status === "rejected") && (
                  <div className="mt-1 small" style={{ color: "#000000" }}>
                    <strong>Rejection Reason:</strong>{" "}
                    {rejectionReason || "N/A"}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ApprovalStepper;
